import { Component, EventEmitter, Input, Output } from '@angular/core';

import { OpportunityListItem } from '@features/opportunities/models/opportunity';
import { UserList } from '@core/services/user';

// TODO: review setup as shared but dependant on feature module
@Component({
  selector: 'app-opportunity-list-view',
  templateUrl: './opportunity-list-view.component.html',
  styleUrls: ['./opportunity-list-view.component.scss']
})
export class OpportunityListViewComponent  {
  @Input()
  opportunities: OpportunityListItem[] = [];

  @Input()
  users: UserList = new UserList([]);

  @Input()
  isNavigatable: boolean = false;

  @Output()
  clicked: EventEmitter<OpportunityListItem> = new EventEmitter<OpportunityListItem>();

  constructor() { }

  public onClick(opportunity: OpportunityListItem) {
    this.clicked.emit(opportunity);
  }
}
